import Search, { SEARCH_HITS_PER_PAGE } from '~/components/Slices/Search'

import { ClientPageView } from '~/providers/GTMTrackingProvider/ClientPageView'
import ShopifySearchProvider from '~/providers/ShopifySearchProvider'

import getSearchPageStaticPropsFunction from '~/data/search-page-data'
import { SearchPageData } from '~/data/search-page-data/serializer'

function SearchPage({ searchInitialData, queryValue }: SearchPageData) {
  return (
    <>
      <ShopifySearchProvider
        queryKey="shopify-search"
        hitsPerPage={SEARCH_HITS_PER_PAGE}
        query={queryValue ?? ''}
        initialData={searchInitialData}>
        <Search />
      </ShopifySearchProvider>
      <ClientPageView template="search" />
    </>
  )
}

export default SearchPage

export const getStaticProps = getSearchPageStaticPropsFunction()
